import { render, staticRenderFns } from "./AboutFeaturedOn.vue?vue&type=template&id=56596ccc&scoped=true"
import script from "./AboutFeaturedOn.vue?vue&type=script&lang=js"
export * from "./AboutFeaturedOn.vue?vue&type=script&lang=js"
import style0 from "./AboutFeaturedOn.vue?vue&type=style&index=0&id=56596ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56596ccc",
  null
  
)

export default component.exports